document.addEventListener('DOMContentLoaded' , () =>{
    // tab    
    const tabModule = document.querySelectorAll('.js_tabModule');

    class tab {
        constructor(target) {
            this.target = target;
            this.tabBtnArray = Array.from(this.target.querySelectorAll('.js_btn'));
            this.tabConArray = Array.from(this.target.querySelectorAll(".js_tabContents"));
        }
    
        tabFn() {
            const _this = this;
            
            this.tabBtnArray.forEach(function(el,index){
                el.addEventListener("click" , function(){
                    // console.log(_this.tabBtnArray.indexOf(el) , index) 1,1 / 2,2
                    // if(tabBtnArray.indexOf(index) == -1){                         
                    // }                    

                    _this.tabBtnArray.forEach(function(el){
                        el.classList.remove("on");
                    });                    

                    _this.tabBtnArray[index].classList.add("on");         

                    _this.tabConArray.forEach(function(el){
                        el.classList.remove("on");
                    })

                    _this.tabConArray[index].classList.add("on");
                })
            })
        }
    }    
    tabModule.forEach(el => {        
        new tab(el).tabFn();
    });
});
